<template>
  <div>
    <div>
      <div class="row">
        <div class="col-12 col-md-6 my-2">
          <label for="farsi_name">
            {{ $t("label.farsi_name") }}
          </label>
          <input
            id="farsi_name"
            name="farsi_name"
            class="form-control"
            v-model="form_data.farsi_name"
          />
          <small v-if="next_step_clicked && !validation_errors.farsi_name" class="text-danger px-2">تکمیل این فیلد الزامی است.</small>
        </div>
        <div class="col-12 col-md-6 my-2">
          <label for="english_name">
            {{ $t("label.english_name") }}
          </label>
          <input
            id="english_name"
            name="english_name"
            class="form-control"
            v-model="form_data.english_name"
            dir="ltr"
          />
          <small v-if="next_step_clicked && !validation_errors.english_name" class="text-danger px-2">تکمیل این فیلد الزامی است.</small>
        </div>

        <div class="col-12 col-md-6 my-2">
          <label for="subcategory_code">
            {{ $t("label.subcategory_code") }}
          </label>
          <select
            id="subcategory_code"
            name="subcategory_code"
            v-model="form_data.subcategory_code"
            class="form-control kt-selectpicker"
          >
            <option
              v-bind:key="subcategory.key"
              v-for="subcategory in subcategories"
              :value="subcategory.key"
            >
              {{ subcategory.value }}
            </option>
          </select>
          <small v-if="next_step_clicked && !validation_errors.subcategory_code" class="text-danger px-2">تکمیل این فیلد الزامی است.</small>
        </div>

        <div v-if="form_data.wizard_gateway_type == '1'" class="col-12 col-md-6 my-2">
          <label for="site_address">
            {{ $t("label.site_address") }}
          </label>
          <input
            dir="ltr"
            id="site_address"
            name="site_address"
            class="form-control"
            disabled
            v-model="form_data.site_address"
          />
          <small v-if="next_step_clicked && !validation_errors.site_address" class="text-danger px-2">تکمیل این فیلد الزامی است.</small>
        </div>
        <div v-else class="col-12 col-md-6 my-2">
          <label for="site_address">
            {{ $t("label.site_address") }}
          </label>
          <input
            disabled
            dir="ltr"
            id="site_address"
            name="site_address"
            class="form-control"
            v-model="form_data.site_address"
          />
          <small v-if="next_step_clicked && !validation_errors.site_address" class="text-danger px-2">تکمیل این فیلد الزامی است.</small>
          <!-- <div class="my-2">
              <small class="py-2 badge badge-danger">  جهت ثبت درگاه پرداخت اختصاصی , مشخصات صاحب امتیاز نماد اعتماد الکترونیک باید با پذیرنده درگاه یکسان باشد </small>
          </div> -->
        </div>

        <div class="col-12 col-md-6 my-2">
          <label for="wage">
            {{ $t("label.wage") }}
          </label>
          <select
            id="wage"
            name="wage"
            v-model="
              form_data.merchant_share_percent != 0 &&
              form_data.merchant_share_percent != 100
                ? (wage_s = 50)
                : form_data.merchant_share_percent
            "
            @change="selectChange($event)"
            class="form-control kt-selectpicker"
          >
            <option v-for="wage in wages" v-bind:key="wage.id" :value="wage.id">
              {{ wage.value }}
            </option>
          </select>
          <small v-if="next_step_clicked && !validation_errors.merchant_share_percent" class="text-danger px-2">تکمیل این فیلد الزامی است.</small>
        </div>

        <div
          class="col-12 col-md-3 my-2"
          v-if="
            form_data.merchant_share_percent != 0 &&
            form_data.merchant_share_percent != 100
          "
        >
        
          <div>
            <label for="merchant_wage_share">
              {{ $t("label.merchant_wage_share") }}
            </label>
            <input
              type="number"
              max="100"
              min="0"
              id="merchant_share_percent"
              name="merchant_share_percent"
              v-model="form_data.merchant_share_percent"
              class="form-control kt-selectpicker"
            />
          </div>
        </div>

        <div
          class="col-12 col-md-3 my-2"
          v-if="
            form_data.merchant_share_percent != 0 &&
            form_data.merchant_share_percent != 100
          "
        >
          <div>
            <label for="client_wage_share">
              {{ $t("label.client_wage_share") }}
            </label>

            <p
              class="form-control disabled"
              id="client_wage_share"
              name="client_wage_share"
            >
              {{
                !form_data.merchant_share_percent
                  ? ""
                  : 100 - form_data.merchant_share_percent
              }}
            </p>
          </div>
        </div>
        <div class="col-12 col-md-6 my-2">
          <div class="col-12 col-md-6 my-2">
          <label>
            {{ $t("label.logo") }}
          </label>
          <label
            for="logo_file"
            class="d-block btn btn-secondary btn-wide label-file"
          >
            <kt-icon type="fa" name="paperclip"></kt-icon>
            {{ $t("gateway.btn.click_me") }}
          </label>
          <input
            @change="processLogoFile"
            type="file"
            class="custom-file-upload d-none"
            name="logo"
            id="logo_file"
            accept="image/*"
          />
          <small v-if="next_step_clicked && !validation_errors.logo" class="text-danger px-2">تکمیل این فیلد الزامی است.</small>
          </div></div>
                <div  class="col-12 col-md-6 my-2">
              <div >
                  <div class="form-group form-check d-flex">
                      <label class="switch">
                          <input  type="checkbox" class="custom-control-input" id="has_limit2" name="has_limit"
                                 v-model="abroad_ips_only_by_user">
                          <span class="slider round"></span>
                      </label>
                      <p dir="rtl" class="mx-3">{{ $t('label.abroad_ip_limitation_by_user') }}</p>
                  </div>
                  <transition name="fade">
                      <kt-form-group v-if="abroad_ips_only_by_user">
                          <kt-form-label>
                              {{ $t('label.limit_amount') }}
                          </kt-form-label>
                          <div class="kt-input-icon kt-input-icon--right">
                    <span class="kt-input-icon__icon kt-input-icon__icon--right">
                        <span>{{ $t('label.rial') }}</span>
                    </span>
                              <kt-form-control
                                      type="text"
                                      dir="ltr"
                                      id="limit_amount"
                                      name="limit_amount"
                                      v-model="form_data.limit_amount_by_user"
                              >
                              </kt-form-control>
                          </div>
                      </kt-form-group>
                  </transition>
              </div>

          </div>
          <div class="col-12 col-md-6 my-2">
            <img :src="picPreview" class="preview_picture"  v-if="picPreview !== ''"/>
            <i class="fa fa-window-close text-danger remove_picture" v-if="picPreview !== ''" @click="removePicture"></i>
          </div>
        </div>
      </div>
    <div class="d-flex align-items-center px-3 mt-4">
      <div>
        <button
          type="button"
          @click="step_back()"
          class="btn btn-success px-4"
          style="border-radius: 10px"
        >
          <span>مرحله قبل</span>
        </button>
      </div>
      <div class="mr-auto">
        <button
          type="button"
          @click="next_step()"
          class="btn btn-success px-4"
          style="border-radius: 10px"
        >
          <span>مرحله بعد</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { i18n } from "@/plugins/i18n";
import { subcategories } from "@/constants/subcategories";
import Inputmask from "inputmask";
import { mapGetters } from "vuex";
import p2f from 'persian-to-pinglish';
import { getFinglish } from '@/constants/names';

export default {
  props: {
    wizard: Object,
    form_data: Object,
  },
  computed: {
    ...mapGetters("shebaNumber", ["sheba_numbers"]),
    gateway_farsi_name() {
      return this.form_data.farsi_name;
    }
  },
  watch: {
    gateway_farsi_name() {
      let finglish = getFinglish(this.form_data.farsi_name);
      
      if (finglish) {
        this.form_data.english_name = finglish;
      } else {
        this.form_data.english_name = p2f(this.form_data.farsi_name);
      }
    },
    validation_errors() {
      this.next_step_clicked = false;
    }
  },
  data() {
    return {
       abroad_ips_only_by_user:false,
        ip_limitations:[
            {
                name:"ندارد",
                value:0,
            },
            {
                name:"دارد",
                value:1,
            }
        ],
        abroad_ips_only:false,
      next_step_clicked: false,
      validation_errors: {},
      subcategories: subcategories,
      wages: [
        {
          id: 0,
          value: this.$t("gateway.wages.from_payer"),
        },
        {
          id: 100,
          value: this.$t("gateway.wages.from_me"),
        },
        {
          id: 50,
          value: this.$t("gateway.wages.half"),
        },
      ],
      picPreview: ''
    };
  },
  mounted() {
    if (this.$store.getters["pardakhtShakhsi/status"] != 'success') {
      this.$store.dispatch("pardakhtShakhsi/fetch");
    }
  },
  methods: {
    step_back() {
      this.wizard.current_step = 1;
    },
    next_step() {
      this.form_data.abroad_ips_only_by_user=this.abroad_ips_only_by_user === true ? 1 : 0;
      this.next_step_clicked = true;

      if (this.step_is_valid()) {
        this.validation_errors = {};
        this.wizard.current_step = 3;
      }
    },
    step_is_valid() {
      this.validation_errors.farsi_name             = !!this.form_data.farsi_name;
      this.validation_errors.english_name           = !!this.form_data.english_name;
      this.validation_errors.subcategory_code       = !!this.form_data.subcategory_code;
      this.validation_errors.site_address           = (!!this.form_data.site_address && this.form_data.site_address != 'https://');
      this.validation_errors.merchant_share_percent = !!this.form_data.merchant_share_percent;
      

      return this.validation_errors.farsi_name
          && this.validation_errors.english_name
          && this.validation_errors.subcategory_code
          && this.validation_errors.site_address
          && this.validation_errors.merchant_share_percent
         
    },
    processLogoFile(e) {
      this.form_data.logo = event.target.files[0];
      this.picPreview = URL.createObjectURL(e.target.files[0]);
      if (this.validateSize(event.target)) {
        this.validateFormat(event.target);
      }
    },
    removePicture(){
      this.picPreview = ''
    },
    selectChange(event) {
      if (event.target.value == 0 || event.target.value == 100)
        this.form_data.merchant_share_percent = event.target.value;
    },
    validateSize(file) {
      var FileSize = file.files[0].size / 1024 / 1024; // in MB
      if (FileSize > 1) {
        alert(i18n.t("authenticate.hint.fourth"));
        $(file).val("");
        this.form_data.logo = null;
        return false;
      }

      return true;
    },
    validateFormat(file) {
      let jq_file = $(file);
      let file_name = jq_file.val();
      let extension = file_name.replace(/^.*\./, "");
      if (extension === file_name) {
        extension = "";
      } else {
        extension = extension.toLowerCase();
      }

      switch (extension) {
        case "png":
        case "jpeg":
        case "jpg":
          break;
        default:
          alert(i18n.t("authenticate.input_format_err"));
          $(file).val("");
          this.form_data.logo = null;
          return false;
      }

      return true;
    },
  },
};
</script>

<style scoped>
.preview_picture{
  width: 50%;
  height: 150px;
}
.remove_picture{
  cursor: pointer;
  position: absolute;
  top: -5px;
  right: 10px;
}
</style>